import { css } from '@inter-ikea-kompis/web-component';

import { Text } from '@ingka/common-styles-webc';
import * as tokens from '@ingka/variables/design-tokens';

export default class SaveDesignToProfileStyle {
	public static getStyle(): string {
		return css`
			${Text.CSS}

			h2 {
				margin-top: 0;
				margin-bottom: ${tokens.space100};
			}

			skapa-inline-message {
				margin-top: ${tokens.space100};
			}
		`;
	}
}
